export enum NextuActivityType {
  COURSES_COMPLETED = 'COURSES_COMPLETED',
  LIVE_CLASSES_ATTENDED = 'LIVE_CLASSES_ATTENDED',
  LESSONS_COMPLETED = 'LESSONS_COMPLETED',
  ACTIVE_HOURS = 'ACTIVE_HOURS',
}
